import { Spinner } from '../ui/spinner'

interface LoadingOverlayProps {
  isLoading: boolean
}

export function LoadingOverlay({ isLoading }: LoadingOverlayProps) {
  if (!isLoading) return null

  return (
    <div className='absolute inset-0 flex items-center justify-center cursor-not-allowed bg-black/16'>
      <Spinner className='size-8' />
    </div>
  )
}
